// extracted by mini-css-extract-plugin
export default {"links":"HeaderList_links__3sCF+"};